import { defineMessages } from 'react-intl';

export default defineMessages({
  mattressRemovalInTitle: {
    id: 'DeliveryMethodStepInfoCard.mattressRemovalInTitle',
    description: 'Mattress removal label for title',
    defaultMessage: 'with Removal',
  },
  productNameAndTitle: {
    id: 'DeliveryMethodStepInfoCard.productNameAndTitle',
    description: 'Product Name and title for product in shipping method',
    defaultMessage: '{productName} | {title}',
  },
  smallProductsTitle: {
    id: 'DeliveryMethodStepInfoCard.smallProductTitle',
    description: 'Title for small products group in shipping method',
    defaultMessage: 'Small Items ({quantity})',
  },
  largeProductsTitle: {
    id: 'DeliveryMethodStepInfoCard.largeProductTitle',
    description: 'Title for large products group in shipping method',
    defaultMessage: 'Large Items ({quantity})',
  },
});
